<template>
	<v-row>
		<v-col cols="12">
			<v-row>
				<v-col cols="12">
					<v-form ref="formProfile" role="form">
						<!-- <v-alert
							dense
							outlined
							type="error"
						>
							Perubahan data pribadi hanya bisa di lakukan oleh admin PT Asta Waya Sentosa. Silakan hubungi Admin apabila ingin melakukan perubahan dat pribadi Anda.
						</v-alert> -->

						<v-card class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
							<v-row>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nama Lengkap" color="red darken-3" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_name" :rules="rules.input" :disabled="!isEditing"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Email" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-email" hide-details="auto" v-model="member_email" :rules="rules.email" :disabled="true" @change="changeInputData"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nomor Identitas" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-card-account-details" hide-details="auto" v-model="data.member_identity_no" disabled></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nomor Handphone" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-cellphone" hide-details="auto" v-model="member_mobilephone" :rules="rules.phone" :disabled="true" @change="changeInputData" @keypress="onlyNumber"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-menu v-model="joinDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field label="Tanggal Gabung" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-calendar-check" hide-details="auto" readonly v-bind="attrs" v-on="on" :value="convertDate(data.member_join_datetime)" disabled></v-text-field>
										</template>
										<v-date-picker locale="id" first-day-of-week="0" color="red darken-3" :max="today" @input="joinDate = false" hide-details="auto" v-model="data.member_join_datetime"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0 mt-4 mb-2 d-flex flex-column flex-md-row align-md-center justify-md-space-between">
									<v-card-subtitle class="py-0 px-0 grey--text lighten-5"><v-icon dense class="mr-2">mdi-account-cog-outline</v-icon>Jenis Kelamin</v-card-subtitle>
									<v-radio-group v-model="member_gender" row hide-details="auto" class="ml-md-5 pl-md-5 mt-4 mt-md-0 pt-0" :disabled="!isEditing" :rules="rules.input">
										<v-radio label="Laki-laki" value="Laki-laki"></v-radio>
										<v-radio label="Perempuan" value="Perempuan"></v-radio>
									</v-radio-group>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Tempat Lahir" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-home-city" hide-details="auto" v-model="member_birth_place" :rules="rules.input" :disabled="!isEditing"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-menu v-model="bornDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field label="Tanggal Lahir" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" :value="convertDate(member_birth_date)" :rules="rules.input" :disabled="!isEditing"></v-text-field>
										</template>
										<v-date-picker locale="id" first-day-of-week="0" color="red darken-3" :max="today" @input="bornDate = false" hide-details="auto" v-model="member_birth_date"></v-date-picker>
									</v-menu>
								</v-col>

								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-autocomplete label="Provinsi" no-data-text="Tidak ada data yang dapat ditampilkan" color="red darken-3" item-color="red darken-3" class="input-regis" prepend-inner-icon="mdi-map-marker" :items="provincesData" item-text="province_name" item-value="province_id" hide-details="auto" v-model="member_province_id" @change="changeProvince" :rules="rules.input" :disabled="!isEditing"></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-autocomplete label="Kabupaten / Kota" no-data-text="Pilih provinsi terlebih dulu" color="red darken-3" item-color="red darken-3" class="input-regis" prepend-inner-icon="mdi-map-marker" :items="citiesData" item-text="city_name" item-value="city_id" hide-details="auto" v-model="member_city_id" :rules="rules.input" :disabled="!isEditing" @change="changeCity">
										<!-- <template v-slot:item="data">
											<div><span>{{ data.item.city_type }} </span><span>{{ data.item.city_name }}</span></div>
										</template>
										<template v-slot:selection="data">
											<div><span>{{ data.item.city_type }} </span><span>{{ data.item.city_name }}</span></div>
										</template> -->
									</v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6" class="px-5">
									<v-autocomplete label="Kecamatan" no-data-text="Pilih kota terlebih dulu" color="red darken-3" item-color="red darken-3" class="input-regis" prepend-inner-icon="mdi-map-marker" :items="subdistrictsData" item-text="subdistrict_name" item-value="subdistrict_id" hide-details="auto" v-model="member_subdistrict_id" :rules="rules.input" :disabled="!isEditing" ></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="12" class="px-5 pb-0">
									<v-textarea label="Alamat Lengkap" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-map-marker-plus" rows="2" counter="255" maxlenght="255" no-resize hide-details="auto" v-model="member_address" :rules="rules.input" :disabled="!isEditing"></v-textarea>
								</v-col>
							</v-row>
						</v-card>

						<v-card class="pa-3 elevation-0 rounded-xl pb-5 mb-3" v-if="false">
							<v-row>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nama Ibu Kandung" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_mother_name" :disabled="!isEditing"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nama Ahli Waris" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_devisor_name" :disabled="!isEditing" @change="changeInputData"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5">
									<v-text-field label="Hubungan Ahli Waris" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_devisor_relation" :disabled="!isEditing" @change="changeInputData"></v-text-field>
								</v-col>
							</v-row>
						</v-card>

						<v-card class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
							<v-row>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-autocomplete label="Nama Bank" no-data-text="Tidak ada data yang dapat ditampilkan" color="red darken-3" item-color="red darken-3" class="input-regis" prepend-inner-icon="mdi-bank-outline" :items="banks" item-text="bank_name" item-value="bank_id" hide-details="auto" v-model="member_bank_id" :rules="rules.input" :disabled="true" ></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nama Rekening" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-clipboard-account-outline" hide-details="auto" v-model="member_bank_account_name" :disabled="true"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5">
									<v-text-field label="Nomor Rekening" color="red darken-3" class="input-regis" prepend-inner-icon="mdi-credit-card-outline" hide-details="auto" v-model="member_bank_account_no" :rules="rules.bank_no" :disabled="true" @change="changeInputData" @keypress="onlyNumber"></v-text-field>
								</v-col>
							</v-row>
						</v-card>
					</v-form>
				</v-col>
			</v-row>
			<v-row class="mt-0 justify-center justify-sm-start">
				<v-col cols="6" sm="3" md="3" v-if="!isEditing">
					<v-btn height="45" depressed block color="red darken-3" class="white--text rounded-xl text-capitalize" @click="isEditing = !isEditing">
						<v-icon>mdi-pencil</v-icon>
						<span class="pl-2 font-size-11 font-weight-bold">Ubah</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="3" md="3" v-if="isEditing">
					<v-btn height="45" depressed block class="grey--text  rounded-xl text--darken-2 text-capitalize" color="grey lighten-2" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="cancelSave">
						<v-icon>mdi-close</v-icon>
						<span class="pl-2 font-size-11 font-weight-bold">Batal</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="3" md="3" v-if="isEditing" class="pl-0">
					<v-btn height="45" depressed block color="red darken-3" class="white--text rounded-xl text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="save">
						<v-icon>mdi-content-save-outline</v-icon>
						<span class="pl-2 font-size-11 font-weight-bold">Simpan</span>
					</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
	components: {

	},
	data() {
		return {
			isEditing: false,
			joinDate: false,
			bornDate: false,
			btnLoadingProses: false,
			isActiveMember: false,
			member_name: '',
			member_email: '',
			member_mobilephone: '',
			member_gender: '',
			member_birth_place: '',
			member_birth_date: '',
			member_province_id: '',
			member_city_id: '',
			member_subdistrict_id: '',
			member_bank_id: '',
			member_bank_account_name: '',
			member_bank_account_no: '',
			member_address: '',
			member_mother_name: '',
			member_devisor_name: '',
			member_devisor_relation: '',
			rules: {
				input: [
				v => !!v || 'Tidak boleh kosong',
				],
				email: [
				v => !!v || 'Tidak boleh kosong',
				v => ( v && !this.errorValidation.member_email ) || "Email sudah digunakan oleh pengguna lain",
				],
				phone: [
				v => !!v || 'Tidak boleh kosong',
				v => ( v && !this.errorValidation.member_mobilephone ) || "Nomor Handphone sudah digunakan oleh pengguna lain",
				],
				bank_no: [
				v => !!v || 'Tidak boleh kosong',
				v => ( v && !this.errorValidation.member_bank_account_no ) || "Nomor Rekening sudah digunakan oleh pengguna lain",
				],
			},
		}
	},
	props: {
		data: { type: Object },
		provincesData: { type: Array },
		citiesData: { type: Array },
		subdistrictsData: { type: Array },
		banks: { type: Array },
	},
	computed: {
		...mapState('profil', ['errorValidation']),
		...mapState('opsi', ['cities']),
	},
	methods: {
		...mapActions('profil', ['getProfileMitra', 'editProfileMitra']),
		...mapActions('opsi', ['getCity', 'getSubdistrict']),
		...mapMutations('profil', ['clearErrorValidation']),

		changeProvince() {
			this.getCity({province_id: this.member_province_id})
			this.member_city_id = ''
			this.member_subdistrict_id = ''
		},
		changeCity() {
			this.getSubdistrict({city_id: this.member_city_id})
			this.member_subdistrict_id = ''
		},
		customFilter (item, queryText) {
			const byName = item.city_name.toLowerCase()
			const byType = item.city_type.toLowerCase()
			const searchText = queryText.toLowerCase()

			return byName.indexOf(searchText) > -1 || byType.indexOf(searchText) > -1
		},
		changeInputData() {
			this.clearErrorValidation()
			this.$refs.formProfile.resetValidation()
		},
		setDataProfile() {
			this.member_name = this.data.member_name
			this.member_email = this.data.member_email
			this.member_mobilephone = this.data.member_mobilephone
			this.member_gender = this.data.member_gender
			this.member_birth_place = this.data.member_birth_place
			this.member_birth_date = this.data.member_birth_date
			this.member_province_id = this.data.member_province_id
			this.member_city_id = this.data.member_city_id
			this.member_subdistrict_id = this.data.member_subdistrict_id
			this.member_bank_id = this.data.member_bank_id
			this.member_bank_account_name = this.data.member_bank_account_name
			this.member_bank_account_no = this.data.member_bank_account_no
			this.member_address = this.data.member_address
			this.member_mother_name = this.data.member_mother_name
			this.member_devisor_name = this.data.member_devisor_name
			this.member_devisor_relation = this.data.member_devisor_relation
		},
		cancelSave() {
			this.isEditing = false
			this.getCity({province_id: this.data.member_province_id}).then(()=> {
				this.getSubdistrict({city_id: this.data.member_city_id}).then(()=> {
					this.setDataProfile()
				})
			})
		},
		async save() {
			if (this.$refs.formProfile.validate()) {
				this.btnLoadingProses = true
				
				let formData = new FormData()
				formData.append('name', this.member_name)
				formData.append('email', this.member_email)
				formData.append('mobilephone', this.member_mobilephone)
				formData.append('gender', this.member_gender)
				formData.append('birth_place', this.member_birth_place)
				formData.append('birth_date', this.member_birth_date)
				formData.append('address', this.member_address)
				formData.append('province_id', this.member_province_id)
				formData.append('city_id', this.member_city_id)
				formData.append('subdistrict_id', this.member_subdistrict_id)
				formData.append('bank_id', this.member_bank_id)
				formData.append('bank_account_name', this.member_bank_account_name)
				formData.append('bank_account_no', this.member_bank_account_no)
				// formData.append('mother_name', this.member_mother_name)
				// formData.append('devisor_name', this.member_devisor_name)
				// formData.append('devisor_relation', this.member_devisor_relation)

				await this.editProfileMitra(formData).then(() => {
					this.getProfileMitra()
					this.btnLoadingProses = false
					this.isEditing = !this.isEditing
				}).catch(() => {
					this.btnLoadingProses = false
					this.$refs.formProfile.validate()
				})
			} else {
				this.btnLoadingProses = false
			}
		},
	},
	async mounted() {
		this.setDataProfile()
	},
};
</script>